var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq13(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.19844,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4348,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 39.0222,
    y1: 12.1824,
    x2: 50.2586,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.34841,
    y1: 49.8543,
    x2: 12.5847,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.7844,
    y1: 38.6199,
    x2: 50.0207,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.11057,
    y1: 0.944118,
    x2: 12.3469,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.434 21.844V20.962H22.814V31H21.82V21.844H20.434ZM24.9559 23.524C25.0212 22.6747 25.3479 22.0073 25.9359 21.522C26.5332 21.0273 27.3032 20.78 28.2459 20.78C28.8712 20.78 29.4079 20.892 29.8559 21.116C30.3039 21.34 30.6399 21.648 30.8639 22.04C31.0972 22.4227 31.2139 22.8567 31.2139 23.342C31.2139 23.93 31.0412 24.4387 30.6959 24.868C30.3506 25.2973 29.8606 25.5633 29.2259 25.666V25.736C29.8886 25.8667 30.4159 26.156 30.8079 26.604C31.1999 27.0427 31.3959 27.6213 31.3959 28.34C31.3959 29.1427 31.1252 29.8007 30.5839 30.314C30.0519 30.818 29.2772 31.07 28.2599 31.07C27.2892 31.07 26.4912 30.818 25.8659 30.314C25.2406 29.8007 24.8812 29.0773 24.7879 28.144H25.7399C25.8239 28.7693 26.0852 29.278 26.5239 29.67C26.9626 30.0527 27.5412 30.244 28.2599 30.244C28.9692 30.244 29.5106 30.0573 29.8839 29.684C30.2666 29.3107 30.4579 28.8347 30.4579 28.256C30.4579 26.8373 29.4359 26.128 27.3919 26.128H27.0839V25.302H27.4059C29.3099 25.302 30.2619 24.6813 30.2619 23.44C30.2619 22.8987 30.0846 22.4647 29.7299 22.138C29.3752 21.802 28.8712 21.634 28.2179 21.634C27.5832 21.634 27.0559 21.802 26.6359 22.138C26.2252 22.4647 25.9826 22.9267 25.9079 23.524H24.9559Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq13);
export default __webpack_public_path__ + "static/media/fq13.3a576bf2878317166cc8fe45b8d9d8d9.svg";
export { ForwardRef as ReactComponent };